import { request } from "services/api/util";

class PrivilegeCategoryService {
  async getListPrivilegeCategories(param) {
    const config = {
      method: "get",
      url: `admin/privilegeCategory`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailPrivilegeCategory(id) {
    const config = {
      method: "get",
      url: `admin/privilegeCategory/${id}`,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createPrivilegeCategory(body) {
    const config = {
      method: "post",
      url: `admin/privilegeCategory`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updatePrivilegeCategory(body, id) {
    const config = {
      method: "put",
      url: `admin/privilegeCategory/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new PrivilegeCategoryService();
